import { CardType } from 'types/deck'

import { useCanEditDeck } from 'redux/deck/selectors'
import { useAppSelector } from 'redux/hooks'

type ExtendedCardData = Record<string, Partial<CardType>>

const useQuantitiesAndIDs = (): ExtendedCardData => {
  const cardMap = useAppSelector(state => state.deck.cardMap)

  const cards = Object.values(cardMap).sort((a, b) => (a.deckRelationId < b.deckRelationId ? 1 : -1))

  return cards.reduce((acc, card) => {
    if (!card.oracleCardId) return acc

    // Base case
    if (!acc[card.oracleCardId]) acc[card.oracleCardId] = { totalPrintingQtyInDeck: 0, relatedCardIds: [] }

    const extendedCardInfo = acc[card.oracleCardId]

    acc[card.oracleCardId] = {
      totalPrintingQtyInDeck: (extendedCardInfo?.totalPrintingQtyInDeck || 0) + card.qty,
      relatedCardIds: [...(extendedCardInfo?.relatedCardIds || []), card.id],
    }

    return acc
  }, {} as ExtendedCardData)
}

const useReplaceCard = (searchedCard: CardType): CardType => {
  const canEditDeck = useCanEditDeck()
  const oracleCardInfo = useQuantitiesAndIDs()
  const cardMap = useAppSelector(state => state.deck.cardMap)

  if (!canEditDeck) return searchedCard

  const cards = Object.values(cardMap).sort((a, b) => (a.deckRelationId < b.deckRelationId ? 1 : -1))

  const oracleCardMatchingInfo: Partial<CardType> = oracleCardInfo[searchedCard.oracleCardId] || {}
  const potentialReplacement = cards.find(deckCard => deckCard.cardId === searchedCard.cardId)

  // No matching card in the deck, but we append the oracleCardMatching info regardless (may be empty, aka no matches in the deck)
  if (!potentialReplacement) return { ...searchedCard, ...oracleCardMatchingInfo }

  return { ...potentialReplacement, ...oracleCardMatchingInfo }
}

export default useReplaceCard
